import angular from 'angular';
import { debounce } from 'lodash';

export const selector = 'dbACheckEventCount';

/* @ngInject */
export default function CheckEventCountDirective($parse, $document, $window) {
    return {
        restrict: 'A',
        
        link: {
            post(scope, element, attrs) {
                const eventHeight = 18;
                const eventSpacing = 4;

                if ($parse(attrs[selector])(scope)) {
                    const onLimitChange = $parse(attrs.onLimitChange)(scope);
                    const resizeHandler = debounce(() => {
                        scope.$applyAsync(() => onLimitChange(getEventCountFit()));
                    }, 100);

                    onLimitChange(getEventCountFit());
                    angular.element($window).on('resize', resizeHandler);
                }

                function getEventCountFit() {
                    let container = findElementByClass('day-content');
                    
                    if (container) {
                        let containerHeight = getElementHeight(container);

                        if (containerHeight) {
                            return Math.floor((containerHeight + eventSpacing) / (eventHeight + eventSpacing));
                        }
                    }

                    return null;
                }

                function findElementByClass(className) {
                    let elements = $document[0].getElementsByClassName(className);

                    if (elements.length > 0) {
                        return elements[0];
                    }

                    return null;
                }

                function getElementHeight(element) {
                    if (element && typeof element.getBoundingClientRect === 'function') {
                        let rectangle = element.getBoundingClientRect();

                        if (rectangle && rectangle.height != null) {
                            return rectangle.height;
                        }
                    }

                    return null;
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/directive/check-event-count/check-event-count.directive.js